import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const NotificationBubbleIllustration = ({
  width = 40,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#6AB3A9"
          d="M36.325 30.43c1.99-3.082 3.146-6.753 3.146-10.694C39.471 8.836 30.635 0 19.736 0 8.836 0 0 8.836 0 19.736S8.836 39.47 19.736 39.47c3.941 0 7.612-1.156 10.694-3.146l9.041 3.146-3.146-9.041z"
        />
        <path
          fill="#FFF"
          d="M29.736 17.734h-20c-.884 0-1.6-.716-1.6-1.6 0-.883.716-1.6 1.6-1.6h20c.883 0 1.6.717 1.6 1.6 0 .884-.717 1.6-1.6 1.6M26.736 24.938h-14c-.884 0-1.6-.716-1.6-1.6 0-.883.716-1.6 1.6-1.6h14c.883 0 1.6.717 1.6 1.6 0 .884-.717 1.6-1.6 1.6"
        />
        <path
          fill="#000"
          d="M19.736 39.471c3.941 0 7.612-1.155 10.694-3.146l9.041 3.146-3.146-9.041c1.99-3.082 3.146-6.753 3.146-10.694C39.471 8.836 30.635 0 19.736 0v39.471z"
          opacity=".1"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
